import {Component, inject} from '@angular/core';
import {TypeProjectShowcaseWithoutUnresolvableLinksResponse} from '../../../../core/types/contentful.types';
import {ContentfulService} from '../../../../core/services/contentful.service';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
    selector: 'wci-compact-projects',
    imports: [],
    templateUrl: './compact-projects.component.html',
    styles: ``,
})
export class CompactProjectsComponent {
    service = inject(ContentfulService);
    items = toSignal<TypeProjectShowcaseWithoutUnresolvableLinksResponse[]>(this.service.getShowcasedProjects());
}
